module.exports = __webpack_public_path__ + "media/se_add_score.4a59c5bb.mp3";